// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum ProjectType {
  standAlone = 'StandAlone',
  project = 'Project',
  projectGroup = 'Project Group',
}
